module.exports = __webpack_public_path__ + "img/granted-tag.e93e6fc2.svg";